import React from 'react'
import _ from 'lodash'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './style'
import { ENERGY_TYPE } from './constant'
import { convertUnits } from './utils'
import moment from 'moment'

function CustomCrosshair(props) {
  const classes = useStyles()
  let time

  const getContentView = () => {
    const data = _.get(props, 'data', [])
    const view = []
    time = moment.unix(data[0].x).clone().format('h:mm A').toString()
    const { trackLegends } = props
    if (trackLegends) {
      _.each(data, (chvalue, key) => {
        const convertedData = chvalue && convertUnits(chvalue.raw * 4, 'watts')
        switch (chvalue.key) {
          case ENERGY_TYPE.PRODUCTION.KEY:
            trackLegends.production && chvalue.raw && view.push({
              classes: classes.produced,
              label: 'Produced:',
              value: convertedData.absDisplay,
              unit: convertedData.abv
            })
            break
          case ENERGY_TYPE.CONSUMPTION.KEY:
            trackLegends.consumption && chvalue.raw && view.push({
              classes: classes.consumed,
              label: 'Consumed:',
              value: convertedData.absDisplay,
              unit: convertedData.abv
            })
            break
          case ENERGY_TYPE.IMPORTED.KEY:
            trackLegends.importExport && chvalue.raw && view.push({
              classes: classes.importedExported,
              label: 'Imported:',
              value: convertedData.absDisplay,
              unit: convertedData.abv
            })
            break
          case ENERGY_TYPE.EXPORTED.KEY:
            trackLegends.importExport && chvalue.raw && view.push({
              classes: classes.importedExported,
              label: 'Exported:',
              value: convertedData.absDisplay,
              unit: convertedData.abv
            })
            break
          case ENERGY_TYPE.BATTERY_CHARGED.KEY:
            trackLegends.battery && chvalue.raw && view.push({
              classes: classes.chargeText,
              label: 'Charged:',
              value: convertedData.absDisplay,
              unit: convertedData.abv
            })
            break
          case ENERGY_TYPE.BATTERY_DISCHARGED.KEY:
            trackLegends.battery && chvalue.raw && view.push({
              classes: classes.chargeText,
              label: 'Discharged:',
              value: convertedData.absDisplay,
              unit: convertedData.abv
            })
            break
          default:
            break
        }
      })
    }

    return view
  }

  const contentView = getContentView()
  const seletectedData = _.get(props, 'data', [])
  const charge = seletectedData.find(obj => obj.key === ENERGY_TYPE.BATTERY_STATUS.KEY)
  const isEmpty = _.isEmpty(contentView) && (_.isEmpty(charge) || charge.raw === 0)
  return (
    <Box className={`${classes.CrossHairCard} ${classes.crossHair} custom-hintbox ${isEmpty ? classes.hide : ''}`}>
      <Box className={`${classes.crossHairTextWrapper} ${classes.border}`}>
        <Typography>Time</Typography>
        <Typography>{time}</Typography>
      </Box >
      <Box>
        <Typography className={classes.cardHeading}>Power</Typography>
        <Box className={_.get(props.trackLegends, 'battery', false) ? classes.border : ''}>
          {contentView.map(obj => (
            <Box className={`${classes.crossHairTextWrapper} ${obj.classes}`}>
              <Typography>{obj.label}</Typography>
              <Typography>{obj.value}<span className={classes.units}>{obj.unit}</span></Typography>
            </Box >
          ))}
        </Box>
        {charge && charge.raw !== 0 && _.get(props.trackLegends, 'battery', false) && <Box className={`${classes.crossHairTextWrapper} ${classes.chargeText}`}>
          <Typography>Charge:</Typography>
          <Typography>{`${charge.raw} %`}</Typography>
        </Box>}
      </Box>
    </Box>
  )
}

export default CustomCrosshair